import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export function onDeleteCourse(course, callback) {
  MySwal.fire({
    title: "Are you sure?",
    text: "You are deleting the folder",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      callback(course.uuid);
      MySwal.fire("Deleted", "You have successfully deleted the folder.", "success");
    }
  });
}

export function onDeleteLecture(lecture, callback) {
  MySwal.fire({
    title: "Are you sure?",
    text: "You are deleting the lecture",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      callback(lecture.uuid);
      MySwal.fire("Deleted", "You have successfully deleted the lecture.", "success");
    }
  });
}

export function onUnenrollFromCourse(course, callback) {
  MySwal.fire({
    title: "Are you sure?",
    text: "You will be unenrolled from the folder",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      callback(course.uuid);
      MySwal.fire("Deleted", "You have successfully unenrolled from the folder.", "success");
    }
  });
}

export function onBanStudent(user, callback) {
  MySwal.fire({
    title: "Are you sure?",
    text: `You will ban ${user.firstName} ${user.lastName}`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, ban!",
  }).then((result) => {
    if (result.isConfirmed) {
      callback(user.email);
      MySwal.fire("Banned", `${user.firstName} ${user.lastName} has been banned from the lecture`, "success");
    }
  });
}

export function onDeleteMessage(uuid, callback) {
  MySwal.fire({
    title: "Are you sure?",
    text: "You are deleting the message",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      callback("chat/deleteMessage", uuid);
      MySwal.fire("Deleted", "You have successfully deleted the message.", "success");
    }
  });
}
